module.exports = __webpack_public_path__ + "img/OA_QR.bf8d60fa.png";